// The application frame: a 240px sidebar that collapses to 64px, a 56px top
// bar with a hairline bottom border, and a scrollable body with a max-width
// wrapper. The shell knows nothing about roles or data: App.jsx passes the
// nav items (already filtered by permission), the title, and the top bar
// actions. Not for the sessionless screens (sign-in, the public form),
// which render without any shell.

import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { PanelLeftClose, PanelLeftOpen } from 'lucide-react'
import './appshell.css'

export function AppShell({ brand, nav, title, actions, children }) {
  const [collapsed, setCollapsed] = useState(false)

  return (
    <div className="ui-shell">
      <nav className={`ui-sidebar${collapsed ? ' is-collapsed' : ''}`} aria-label="Primary">
        <div className="ui-sidebar-brand" title={brand}>
          {collapsed
            ? brand
                ?.split(' ')
                .map((word) => word[0])
                .join('')
                .slice(0, 2)
            : brand}
        </div>
        {nav.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) => `ui-navitem${isActive ? ' is-active' : ''}`}
            title={collapsed ? item.label : undefined}
          >
            {item.icon ? <item.icon size={16} strokeWidth={1.75} aria-hidden="true" /> : null}
            <span className="ui-navitem-label">{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="ui-main">
        <header className="ui-topbar">
          <button
            type="button"
            className="ui-btn ui-btn-icon"
            onClick={() => setCollapsed((was) => !was)}
            aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            {collapsed ? (
              <PanelLeftOpen size={16} strokeWidth={1.75} aria-hidden="true" />
            ) : (
              <PanelLeftClose size={16} strokeWidth={1.75} aria-hidden="true" />
            )}
          </button>
          <h1 className="ui-topbar-title">{title}</h1>
          <div className="ui-topbar-actions">{actions}</div>
        </header>

        <main className="ui-body">
          <div className="ui-body-inner">{children}</div>
        </main>
      </div>
    </div>
  )
}
